import { Box, TablePagination, Typography } from "@mui/material";
import {
  paginationLabel,
  DataTableFooterStyle,
  TablePaginationStyle,
} from "../styles/table";
import { formatTableResultCount } from "../../../utils/formatTableResultCount";

export type DataTableFooterProps = {
  filteredCount: number;
  totalCount?: number | null;
  hasActiveFilters?: boolean;
  countLabel?: string;
  showCountLabel?: boolean;
  page: number;
  pageSize: number;
  onPageChange: (_event: unknown, newPage: number) => void;
  loading?: boolean;
  hidePagination?: boolean;
};

const DataTableFooter = ({
  filteredCount,
  totalCount = null,
  hasActiveFilters = false,
  countLabel,
  showCountLabel = false,
  page,
  pageSize,
  onPageChange,
  loading = false,
  hidePagination = false,
}: DataTableFooterProps) => {
  if (!showCountLabel && hidePagination) {
    return null;
  }

  const label =
    countLabel ??
    formatTableResultCount(filteredCount, totalCount, hasActiveFilters);

  return (
    <Box
      sx={{
        ...DataTableFooterStyle,
        justifyContent: showCountLabel ? "space-between" : "flex-end",
      }}
    >
      {showCountLabel ? (
        <Typography variant="body1" color="text.secondary">
          {loading ? "Loading..." : label}
        </Typography>
      ) : null}
      {!hidePagination ? (
        <TablePagination
          component="div"
          sx={TablePaginationStyle}
          count={filteredCount}
          page={page}
          rowsPerPage={pageSize}
          rowsPerPageOptions={[pageSize]}
          onPageChange={onPageChange}
          labelDisplayedRows={paginationLabel}
        />
      ) : null}
    </Box>
  );
};

export default DataTableFooter;
